import React from "react";
import { Box, Stack } from "@mui/material";
import TabPanel from "@mui/lab/TabPanel";
import { useTranslation } from "react-i18next";

import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { retrieveFinishedOrders } from "./selector";
import { getImageUrl } from "../../../lib/config";
import { Order, OrderItem } from "../../../lib/types/order";
import { Product } from "../../../lib/types/product";
import OrdersEmptyState from "./OrdersEmptyState";

/* REDUX SLICE & SELECTOR*/
// setPopularDishes reduceri orqali setPopularDishes kommandasini hosil qilyabmiz
const pausedFinishedRetriever = createSelector(
  retrieveFinishedOrders,
  (finishedOrders) => ({ finishedOrders })
);

export default function FinishedOrders() {
 const { t } = useTranslation();
 const { finishedOrders } = useSelector(pausedFinishedRetriever);
 const safeFinishedOrders = Array.isArray(finishedOrders) ? finishedOrders : [];

  return (
    <TabPanel value="3">
      <Stack>
        {safeFinishedOrders.map((order: Order) => {
          const orderItems = Array.isArray(order?.orderItems) ? order.orderItems : [];
          const productList = Array.isArray(order?.productData) ? order.productData : [];

          return (
            <Box key={order._id} className="order-main-box">
              <Box className="order-box-scroll">
                {orderItems.map((item: OrderItem) => {
                  const product = productList.find(
                    (ele: Product) => item.productId === ele._id
                  );
                  
                  // Skip rendering if product is not found
                  if (!product || !product.productImages || product.productImages.length === 0) {
                    return null;
                  }
                  
                  const imagePath = product.productImages && product.productImages.length > 0 
                    ? (product.productImages[0].startsWith('http') 
                        ? product.productImages[0] 
                        : getImageUrl(product.productImages[0]))
                    : '/img/noimage-list.svg';
                  return (
                    <Box key={item._id} className="orders-name-price">
                      <img
                        src={imagePath}
                        className="order-dish-img"
                        alt={product.productName || ""}
                      />
                      <p className="title-dish">{product.productName || t("common.unknownProduct")}</p>
                      <Box className="price-box">
                        <p>${item.itemPrice}</p>
                        <img src="/icons/close.svg" alt="" />
                        <p>{item.itemQuantity}</p>
                        <img src="/icons/pause.svg" alt="" />
                        <p style={{ marginLeft: "15px" }}>
                          ${item.itemQuantity * item.itemPrice}
                        </p>
                      </Box>
                    </Box>
                  );
                })}
              </Box>

              <Box className="total-price-box">
                <Box className="box-total">
                  <p>{t("orders.productPrice")}</p>
                  <p>${order.orderTotal - order.orderDelivery}</p>
                  <img
                    src="/icons/plus.svg"
                    style={{ marginLeft: "20px" }}
                    alt=""
                  />
                  <p>{t("orders.deliveryCost")}</p>
                  <p>${order.orderDelivery}</p>
                  <img
                    src="/icons/pause.svg"
                    style={{ marginLeft: "20px" }}
                    alt=""
                  />
                  <p>{t("orders.total")}</p>
                  <p>${order.orderTotal}</p>
                </Box>
              </Box>
            </Box>
          );
        })}

        {safeFinishedOrders.length === 0 && <OrdersEmptyState />}
      </Stack>
    </TabPanel>
  );
}